import { StepIconProps } from "@mui/material"
import { theme } from "@op-str/op-component-library"
import React from "react"
import styled from "styled-components"

export const ServiceBannerStep = (props: StepIconProps) => {
  return <BannerStepLabel>{props.icon}</BannerStepLabel>
}

const BannerStepLabel = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 2px solid ${theme.color.primary100};
  background-color: ${theme.color.white};
`
